import { render } from "./CreateGame.vue?vue&type=template&id=651108cb&scoped=true"
import script from "./CreateGame.vue?vue&type=script&lang=js"
export * from "./CreateGame.vue?vue&type=script&lang=js"

import "./CreateGame.vue?vue&type=style&index=0&id=651108cb&scoped=true&lang=css"
import "./CreateGame.vue?vue&type=style&index=1&id=651108cb&lang=scss"
import "./CreateGame.vue?vue&type=style&index=2&id=651108cb&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651108cb"]])

export default __exports__